import { Component } from 'react';
import PropTypes from 'prop-types';
import { graphql, createFragmentContainer } from 'react-relay/legacy';
import get from 'lodash.get';
import { FormattedMessage } from 'dibs-react-intl';
import PhoneIcon from 'dibs-icons/exports/Phone';
import { Link } from 'dibs-elements/exports/Link';

import { PdpSharedCallDealerModalLoader } from './PdpSharedCallDealerModal/PdpSharedCallDealerModalLoader';
import { sharedLoginCheck } from '../../authentication/sharedLoginCheck';
import { isEmailOnly } from 'dibs-cookie-jar/exports/isEmailOnly';
import authModalLoader from 'dibs-buyer-layout/src/utils/AuthModalLoader';

import styles from './PdpSharedCallDealerCta.scss';

export class PdpSharedCallDealerCtaComponent extends Component {
    constructor() {
        super();
        this.state = {
            isModalOpen: false,
            userId: null,
        };

        this.onAuthSuccess = this.onAuthSuccess.bind(this);
        this.closeModal = this.closeModal.bind(this);
        this.onCallDealerClick = this.onCallDealerClick.bind(this);
    }

    onAuthSuccess({ userId }) {
        this.setState({
            isModalOpen: true,
            userId,
        });
    }

    closeModal() {
        this.setState({ isModalOpen: false });
    }

    onCallDealerClick() {
        const { user } = this.props;
        const ga = { label: 'call seller link' };
        const emailOnly = isEmailOnly(document.cookie);
        if (emailOnly) {
            const { relay } = this.props;
            const email = get(user, 'profile.email');
            authModalLoader
                .show({
                    action: authModalLoader.constants.REQUEST_PASSWORD_EMAIL,
                    flow: authModalLoader.constants.CREATE_PASSWORD_CALL_SELLER_FLOW,
                    email,
                    relayEnvironment: relay.environment,
                    ga,
                })
                .then(({ userId }) => {
                    if (userId) {
                        this.onAuthSuccess({ userId });
                    }
                });
        } else {
            sharedLoginCheck({
                onSuccess: this.onAuthSuccess,
                authOptions: {
                    flow: authModalLoader.constants.CALL_DEALER_FLOW,
                    ga,
                },
            });
        }
    }

    render() {
        const { isModalOpen, userId } = this.state;
        const {
            item,
            item: { seller },
        } = this.props;
        const itemId = get(item, 'serviceId');
        const telephone = get(seller, 'trackedPhone.phoneNumber');
        // userId check was added not to crash on serverside rendering, because 'document' object does not exist.
        const emailOnly = userId && isEmailOnly(document.cookie);
        return telephone ? (
            <div className={styles.contactDealer}>
                <span className={styles.contactDealerLabel}>
                    <FormattedMessage
                        id="PdpSharedCallDealerCta.call_seller"
                        defaultMessage="You may also contact the seller by phone"
                    />
                </span>
                <Link buyerLinkType="standardLink" onClick={this.onCallDealerClick}>
                    <PhoneIcon className={styles.phoneIcon} />
                    <FormattedMessage
                        id="PdpSharedCallDealerCta.cta_link"
                        defaultMessage="Call seller through 1stDibs"
                    />
                </Link>
                {userId && !emailOnly && (
                    <PdpSharedCallDealerModalLoader
                        userId={userId}
                        itemId={itemId}
                        isOpen={isModalOpen}
                        handleCloseClick={this.closeModal}
                        location="pdp"
                    />
                )}
            </div>
        ) : null;
    }
}

PdpSharedCallDealerCtaComponent.propTypes = {
    relay: PropTypes.object.isRequired,
    item: PropTypes.object.isRequired,
    user: PropTypes.object,
};

export const PdpSharedCallDealerCta = createFragmentContainer(PdpSharedCallDealerCtaComponent, {
    item: graphql`
        fragment PdpSharedCallDealerCta_item on Item {
            serviceId
            seller {
                id
                serviceId
                favoritesByUser(userIds: $userId) @include(if: $fetchUser) {
                    serviceId
                }
                trackedPhone {
                    phoneNumber
                }
            }
        }
    `,
    user: graphql`
        fragment PdpSharedCallDealerCta_user on User {
            profile {
                email
            }
        }
    `,
});
